import { useUnsafeCurrentUserContext } from "@/domain/user/hooks/use-current-user-context";
import { useUnsafeCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";
import { AccountType, resolveAccountType } from "@ark/shared";

// The current member's seat tier in the active workspace. Falls back to CORE
// when there is no context to judge from (CORE is the unmarked default, so this
// never wrongly labels someone a guest or hides a control).
export function useCurrentAccountType(): AccountType {
  const userContext = useUnsafeCurrentUserContext();
  const workspaceId = useUnsafeCurrentWorkspaceContext()?.currentWorkspace?.id;

  const membership = userContext?.currentUser.workspaceMembershipList?.find(
    (workspaceMembership) => workspaceMembership.workspaceId === workspaceId,
  );
  return resolveAccountType(membership?.accountType);
}
